import { createApp } from 'vue'
import options from './SessionStorageFormularTest.options'

const el = '.kb-component--session-storage-formular-test'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SessionStorageFormularTestDOM) => {
            const template = SessionStorageFormularTestDOM.outerHTML
            options.template = template
            const component = createApp(options).use(Store)
            component.mount(SessionStorageFormularTestDOM)
        })
    }
}
